import { useState,useEffect } from "react";
import { motion, AnimatePresence  } from "framer-motion";
import {
  BookOpen,
  Eye,
  User,
  FileText,
  Calendar,
  Users,
  Phone,
  Image as ImageIcon,
  X,
  ChevronLeft,
  ChevronRight,
  Mail,
} from "lucide-react";

export default function Cad({ 
  accent = "#115e32",
  pageTitle = "Cultural Affairs Division | University of Creative Technology Chittagong",
}) {
	useEffect(() => {
		document.title = pageTitle;
	}, [pageTitle]);
  const tabs = [
    { id: "about", label: "About CAD", icon: <BookOpen size={18} /> },
    { id: "vision", label: "Vision and Mission", icon: <Eye size={18} /> },
    { id: "message", label: "Message from the Director", icon: <User size={18} /> },    
    { id: "org", label: " Member of CAD", icon: <Users size={18} /> },
    { id: "gallery", label: "Gallery", icon: <ImageIcon size={18} /> },
    { id: "contact", label: "Contact SAD", icon: <Phone size={18} /> },
  ];

	const [activeTab, setActiveTab] = useState("about");
	const [selectedImg, setSelectedImg] = useState(null);
	const [currentIndex, setCurrentIndex] = useState(0);
	const galleryImages = [
		"assets/gallery/21-g-8023.jpeg",
		"assets/gallery/20-g-2243.jpeg",
		"assets/gallery/19-g-7263.jpeg",
		"assets/gallery/18-g-9944.jpeg",
		"assets/gallery/17-g-2570.jpeg",
		"assets/gallery/16-g-8281.jpeg",
		"assets/gallery/15-g-4444.jpeg",
		"assets/gallery/14-g-8690.jpeg",
		"assets/gallery/13-g-3919.jpeg",
		"assets/gallery/12-g-3341.jpeg",
		"assets/gallery/11-g-6385.jpeg",
		"assets/gallery/10-g-989.jpeg",
	];
	const openLightbox = (index) => {
		setCurrentIndex(index);
		setSelectedImg(galleryImages[index]);
	};

	const closeLightbox = () => setSelectedImg(null);

	const prevImage = () => {
		const newIndex = (currentIndex - 1 + galleryImages.length) % galleryImages.length;
		setCurrentIndex(newIndex);
		setSelectedImg(galleryImages[newIndex]);
	};

	const nextImage = () => {
		const newIndex = (currentIndex + 1) % galleryImages.length;
		setCurrentIndex(newIndex);
		setSelectedImg(galleryImages[newIndex]);
	};
  const content = {
    about: (
      <p>
        Cultural Affairs Division (CAD) is an administrative division for students’ extra-curricular activities at UCTC. CAD has been established since the inception of the university with a view to encouraging and actively involving students of UCTC in various extra and co curricular activities at UCTC. It further seeks opportunities to encourage students to create proper platforms such as clubs and societies to represent themselves and to sharpen their creative talents.
      </p>
    ),
    vision: (
      <p>
        <strong>Vision:</strong><br/>
		CAD open doors to extracurricular activities to develop students’ ability to gain skills needed for work and life.
		<br/><br/>
		<strong>Mission:</strong>
		<ul class="space-y-4">
			<li class="flex items-start gap-3 p-4 rounded-lg bg-gradient-to-r from-[#D6F5FE] to-[#E6FAFE] shadow-sm hover:shadow-md transition-all duration-300">
			  <span class="text-[#d4af37] font-bold">a)</span>
			  <p class="text-gray-700 leading-relaxed">
				CAD supports students’ dynamic involvement in extra and co-curricular activities through various UCTC students’ clubs and societies to gain essential skill sets: Collaboration and teamwork, Creativity and imagination, Initiative and leadership, Flexibility and adaptability, Oral and written communication skills, Cultural awareness, Information Technology literacy, Social responsibility and ethics.
		
			  </p>
			</li>
			<li class="flex items-start gap-3 p-4 rounded-lg bg-gradient-to-r from-[#D6F5FE] to-[#E6FAFE] shadow-sm hover:shadow-md transition-all duration-300">
			  <span class="text-[#d4af37] font-bold">b)</span>
			  <p class="text-gray-700 leading-relaxed">
				Students are continually encouraged to join UCTC Cultural Club, a fully functional students’ club at UCTC, to organise, celebrate and perform on various international, national and UCTC events.
		
			  </p>
			</li>
			<li class="flex items-start gap-3 p-4 rounded-lg bg-gradient-to-r from-[#D6F5FE] to-[#E6FAFE] shadow-sm hover:shadow-md transition-all duration-300">
			  <span class="text-[#d4af37] font-bold">c)</span>
			  <p class="text-gray-700 leading-relaxed">
				We welcome students’ proposal to set up clubs or societies relevant to their interest, need and eagerness.
		
			  </p>
			</li>
			<li class="flex items-start gap-3 p-4 rounded-lg bg-gradient-to-r from-[#D6F5FE] to-[#E6FAFE] shadow-sm hover:shadow-md transition-all duration-300">
			  <span class="text-[#d4af37] font-bold">d)</span>
			  <p class="text-gray-700 leading-relaxed">
				We also welcome students’ creative projects, seminars, social engagement programmes to create extracurricular opportunities.
		
			  </p>
			</li>
			<li class="flex items-start gap-3 p-4 rounded-lg bg-gradient-to-r from-[#D6F5FE] to-[#E6FAFE] shadow-sm hover:shadow-md transition-all duration-300">
			  <span class="text-[#d4af37] font-bold">e)</span>
			  <p class="text-gray-700 leading-relaxed">
				We actively seek opportunity to set up clubs (proposed) for students: UCTC Debate Club, Young Writers’ Club, Public Speaking club, Film club, English Language Club, UCTC Photography Society, UCTC Adventure Club, UCTC Social Initiatives and so on.
     
			  </p>
			</li>
			
		</ul>	
	 </p>
    ),
    message: (
      <p>
        "Our mission is to ensure that students at UCTC thrive both inside and
        outside the classroom. The Student Affairs Division is here to guide and
        support you in every step of your academic journey." – Director, SAD
      </p>
    ),
    
    org: (
     
        <motion.div
          initial={{ scale: 0.9, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 1 }}
          className="bg-white rounded-2xl shadow-lg p-8 flex flex-col md:flex-row items-center gap-8 hover:shadow-xl transition-all duration-300"
        >
          <img
            src={`${import.meta.env.VITE_API_SOURCE_URL}assets/teacher/35-2003002-Gazi-Reza-1536.jpg`}
            alt="Prof. Dr. Zahid Hossain Sharif"
            className="w-48 h-56 object-cover rounded-xl border-4 border-[#d4af37]"
          />
          <div className="flex-1 space-y-3">
            <h2 className="text-2xl font-bold text-gray-800">Prof. Dr. Zahid Hossain Sharif, Vice Chancellor</h2>
            <p className="text-[#2563eb] font-semibold">Advisor</p>           
            <div className="space-y-1 text-gray-600 text-sm">             
              <p className="flex items-center gap-2"><Mail size={16}/> zhsharif@uctc.edu.bd</p>
              
            </div>           
          </div>
        </motion.div>
      
    ),
    gallery: (
      <div>
        <h2 className="text-2xl font-semibold mb-4 text-gray-800">Campus Gallery</h2>
        <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
          {galleryImages.map((img, i) => (
            <motion.div
              key={i}
              whileHover={{ scale: 1.05 }}
              className="overflow-hidden rounded-xl shadow-lg cursor-pointer"
              onClick={() => openLightbox(i)}
            >
              <img
                src={`${import.meta.env.VITE_API_SOURCE_URL}${img}`}
                alt="Gallery"
                className="w-full h-40 object-cover hover:scale-110 transition-transform duration-500"
              />
            </motion.div>
          ))}
        </div>
      </div>
    ),
    contact: (
      <p>
		<strong>To request help, contact Student Affairs Division to the following;</strong><br/>
		<strong>Location:</strong> 1st Floor, UCTC Campus<br/>
		<strong>Hours:</strong> Monday through Saturday, 9.00 AM to 6.00 PM<br/>
        <strong>Email:</strong> sad@uctc.edu.bd <br />
        <strong>Phone:</strong> 8801707507071 <br />
        <strong>Mailing Address:</strong> Student Affairs Division, University of Creative Technology, Chittagong, 1084, Near New Chandgaon Police Station, Shah Amanat Bridge Connecting Road, Bahaddarhat, Chittagong, Bangladesh
      </p>
    ),
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-white via-[#fffdf7] to-white">
      {/* Hero Section */}
      <section className="relative bg-gradient-to-r from-[#B7EAFC] via-[#D6F5FE] to-[#E6FAFE] text-[#014864] py-20 overflow-hidden">
        <svg
          className="absolute bottom-0 left-0 w-full h-20 text-white"
          viewBox="0 0 1440 320"
          fill="currentColor"
        >
          <path
            fillOpacity="1"
            d="M0,192L80,202.7C160,213,320,235,480,224C640,213,800,171,960,144C1120,117,1280,107,1360,101.3L1440,96V320H0Z"
          ></path>
        </svg>
        <div className="relative container mx-auto text-center z-10">
          <motion.h1
            initial={{ y: -40, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 1 }}
            className="text-4xl md:text-6xl font-extrabold"
          >
            Cultural Affairs Division
          </motion.h1>
          <p className="mt-4 text-lg opacity-90">
            Supporting students’ academic journey, leadership, and campus life.
          </p>
        </div>
      </section>

      {/* Main Content */}
      <section className="container mx-auto px-6 py-16 grid md:grid-cols-4 gap-8">
        {/* Left Menu */}
        <div className="col-span-1 bg-white rounded-xl shadow-lg p-6">
          <ul className="space-y-3">
            {tabs.map((tab) => (
              <li key={tab.id}>
                <button
                  onClick={() => setActiveTab(tab.id)}
                  className={`flex items-center gap-2 w-full px-4 py-2 rounded-lg text-left transition ${
                    activeTab === tab.id
                      ? "bg-gradient-to-r from-[#2563eb] to-[#014864] text-white shadow"
                      : "text-gray-700 hover:bg-gray-100"
                  }`}
                >
                  {tab.icon} {tab.label}
                </button>
              </li>
            ))}
          </ul>
        </div>

        
        {/* Right Content */}
        <motion.div
          key={activeTab}
          initial={{ opacity: 0, x: 50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6 }}
          className="col-span-3 bg-white rounded-xl shadow-lg p-8 text-gray-700 leading-relaxed"
        >
          {content[activeTab]}
        </motion.div>
      </section>
	   {/* Lightbox Modal */}
      <AnimatePresence>
        {selectedImg && (
          <motion.div
            className="fixed inset-0 bg-black bg-opacity-90 flex items-center justify-center z-50"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            <button
              className="absolute top-6 right-6 text-white text-3xl"
              onClick={closeLightbox}
            >
              <X size={32} />
            </button>
            <button
              className="absolute left-6 text-white text-3xl"
              onClick={prevImage}
            >
              <ChevronLeft size={36} />
            </button>
            <motion.img
              key={selectedImg}
              src={`${import.meta.env.VITE_API_SOURCE_URL}${selectedImg}`}
              alt="Full View"
              initial={{ scale: 0.8 }}
              animate={{ scale: 1 }}
              exit={{ scale: 0.8 }}
              transition={{ duration: 0.4 }}
              className="max-h-[80vh] max-w-[90vw] rounded-lg shadow-2xl"
            />
            <button
              className="absolute right-6 text-white text-3xl"
              onClick={nextImage}
            >
              <ChevronRight size={36} />
            </button>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
